import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {
    getDateRangeSelection,
    getEditedFeedId,
    getFeedName,
    getLeaveTypeSelectionForServer,
    getLightBoxType,
    getSharedUserSelection,
    getUserSelection
} from './selectors'
import {handleError, handleExceptions, setEntitiesByICalResult, setRecentlyConfiguredFeedId} from '../../actions'
import {ICalLightboxType} from '../../constants'
import {rpcCall} from '../../../../../js/util/rpc/rpcCalls'
import messageResource from '../../../../../js/messageResource'
import {DateFormat} from '../../../../../js/date_format'
import {saveFile} from '../../../../../js/atUtils'
import {createActionObject} from '../../../../../js/redux/utils'

export const setFeedName = createAction(ActionTypes.FEED_NAME_SET)
export const setFeedLeaveTypeSelection = createAction(ActionTypes.LEAVE_TYPE_SELECTION_SET)
export const setIncludeNotApproved = createAction(ActionTypes.INCLUDE_NOT_APPROVED_SET)
export const setUserSelection = createAction(ActionTypes.USER_SELECTION_SET)
export const setSharedUserSelection = createAction(ActionTypes.SHARED_USER_SELECTION_SET)
export const setDateRangeSelection = createAction(ActionTypes.DATE_RANGE_SELECITON_SET)
export const closeICalLightBox = createAction(ActionTypes.CLOSE_ICAL_LIGHTBOX)

export const openEditFeedLightBox = id => (dispatch) => {
    dispatch(createActionObject(ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD))
    rpcCall('ICalFeedSettingsService.getFeedSettingsInfo', [id], handleExceptions)
        .then(result => {
            dispatch(setEntitiesByICalResult(result.entitiesInfo))
            const feed = result.feedSettings[0]
            dispatch(createActionObject(ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD_SUCCESS, feed))
        })
        .catch(error => {
            dispatch(createActionObject(ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD_FAILURE))
            dispatch(handleError(error))
        })
}

export const openCreateFeedLightBox = () => (dispatch) => {
    dispatch(createActionObject(ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD))
    rpcCall('ICalFeedSettingsService.getEntitiesInfo', [], handleExceptions)
        .then(result => {
            dispatch(setEntitiesByICalResult(result))
            dispatch(createActionObject(ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD_SUCCESS))
        })
        .catch(error => {
            dispatch(createActionObject(ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD_FAILURE))
            dispatch(handleError(error))
        })
}

export const openExportICalLightBox = () => (dispatch) => {
    dispatch(createActionObject(ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD))
    rpcCall('ICalFeedSettingsService.getEntitiesInfo', [], handleExceptions)
        .then(result => {
            dispatch(setEntitiesByICalResult(result))
            dispatch(createActionObject(ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD_SUCCESS))
        })
        .catch(error => {
            dispatch(createActionObject(ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD_FAILURE))
            dispatch(handleError(error))
        })
}

const createFeed = (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.CREATE_FEED_LOAD_DATA))
    rpcCall('ICalFeedSettingsService.createICalFeedSettings',
        getParamsForCreateOrEditFeed(getState()),
        handleExceptions
    ).then(result => {
        dispatch(createActionObject(ActionTypes.CREATE_FEED_LOAD_DATA_SUCCESS, result))
        dispatch(setRecentlyConfiguredFeedId(result.id))
    }).catch(error => {
        dispatch(createActionObject(ActionTypes.CREATE_FEED_LOAD_DATA_FAILURE))
        dispatch(handleError(error))
    })
}

const editFeed = (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.EDIT_FEED_LOAD_DATA))
    const state = getState()
    rpcCall('ICalFeedSettingsService.editICalFeedSettings',
        [getEditedFeedId(state)].concat(getParamsForCreateOrEditFeed(state)),
        handleExceptions
    ).then(result => {
        dispatch(createActionObject(ActionTypes.EDIT_FEED_LOAD_DATA_SUCCESS, result))
        dispatch(setRecentlyConfiguredFeedId(result.id))
    }).catch(error => {
        dispatch(createActionObject(ActionTypes.EDIT_FEED_LOAD_DATA_FAILURE))
        dispatch(handleError(error))
    })
}

export const exportICal = () => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.EXPORT_ICAL_LOAD_DATA))
    const state = getState()
    const dateRangeSelection = getDateRangeSelection(state)
    rpcCall('ICalFeedSettingsService.getLeaveScheduleICalendar',
        [
            getUserSelection(state),
            getLeaveTypeSelectionForServer(state),
            dateRangeSelection
        ],
        handleExceptions
    ).then(result => {
            const dateFormat = new DateFormat('MMM dd, yyyy')
            const fileName = messageResource.getMessage('icalendar.page.export.file.name',
                [dateFormat.formatDate(dateRangeSelection.fromDate), dateFormat.formatDate(dateRangeSelection.toDate)])
            saveFile(result, fileName, {type: 'text/calendar', encoding: 'UTF-8'})
            dispatch(createActionObject(ActionTypes.EXPORT_ICAL_LOAD_DATA_SUCCESS))
        }
    ).catch(error => {
        dispatch(createActionObject(ActionTypes.EXPORT_ICAL_LOAD_DATA_FAILURE))
        dispatch(handleError(error))
    })
}

export const saveFeedSettings = () => (dispatch, getState) => {
    const lightboxType = getLightBoxType(getState())
    if (lightboxType === ICalLightboxType.CREATE) {
        dispatch(createFeed)
    } else if (lightboxType === ICalLightboxType.EDIT) {
        dispatch(editFeed)
    }
}

const getParamsForCreateOrEditFeed = (state) => [
    getFeedName(state),
    getUserSelection(state),
    getLeaveTypeSelectionForServer(state),
    getSharedUserSelection(state),
]



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/actions.js